<title>Autoverkoop Partner - Extra informatie aanleveren</title>

<!-- Page Content -->
<div class="container">
  <div class="card border-0 shadow my-5">
    <div class="card-body p-5">
      <img class="img-fluid header-img" src="/assets/images/avp-logo.png">
      <hr>

        <h1 class="font-weight-light">Extra informatie aanleveren</h1>

        <p class="lead">We hebben nog wat extra gegevens van je nodig. Vul deze meteen even in of doe dit op een
        later moment.</p>

        @if (submitError != null) {
          <div class="alert alert-danger" role="alert">
            Er is een fout opgetreden: {{submitError}}
          </div>
        }

        <form [formGroup]="validationForm">

          @if (showFrontUpload == false && showBackUpload == false) {
            <div>
              <label><b>Kopie RDW kentekencard</b></label>
              <p>✅ Kentekencard is geüpload.</p>
            </div>
          }

          <div class="form-group">
            <label><b>Heb je de RDW tenaamstellingscodes in uw bezit?</b></label>

            <div class="row">
              <div class="form-group col">
                <div class="custom-control custom-radio custom-control-inline">
                  <input (change)="handleRDWChange(true)" type="radio" class="custom-control-input"
                    id="rdwRadioTrue" name="rdwRadio" value="true">
                  <label class="custom-control-label" for="rdwRadioTrue">Ja</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input (change)="handleRDWChange(false)" type="radio" class="custom-control-input"
                    id="rdwRadioFalse" name="rdwRadio" value="false">
                  <label class="custom-control-label" for="rdwRadioFalse">Nee</label>
                </div>
              </div>
            </div>

            @if (rdwCodesKnown == false) {
              <div>
                <div class="alert alert-warning" role="alert">
                  Zonder tenaamstellingscodes kun je op dit moment niet verder. Vraag deze indien nodig
                  opnieuw aan bij de RDW.
                </div>
              </div>
            }

            <div class="row">
              <div class="form-group col">
                <div ngbAccordion>
                  <div ngbAccordionItem [collapsed]="true">
                    <h2 ngbAccordionHeader>
                      <button class="btn btn-primary" ngbAccordionButton>Meer informatie over
                      tenaamstellingscodes...</button>
                    </h2>
                    <div ngbAccordionCollapse>
                      <div ngbAccordionBody>
                        <ng-template>
                          <p>
                            Bij de kentekencard hoort een unieke code: de tenaamstellingscode.
                            <br>Deze
                              code
                              heb je nodig als je jouw auto wilt verkopen, en bestaat uit 9
                              cijfers.<br>
                              Het 1e deel van de code heb je ontvangen toen je de auto
                              kocht.<br>Het 2e
                              deel
                              zat bij de kentekencard die je toegestuurd hebt gekregen. <br> Ben
                              je de
                              tenaamstellingscodes kwijt? Dan kun je die opnieuw aanvragen bij de
                              RDW.
                              <br><br>
                              <img src="../../assets/images/tenaamstellingcodes brief voorbeeld.jpg"
                                class="card-image img-fluid"
                                alt="Tenaamstellingcodes brief voorbeeld">
                            </p>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            @if (rdwCodesKnown == null || rdwCodesKnown == false) {
              <div style="height: 700px"></div>
            }

            @if (rdwCodesKnown == true) {
              <div>
                <div class="alert alert-primary" role="alert">
                  Zorg ervoor dat je de tenaamstellingscodes bij de hand hebt wanneer wij je voertuig komen
                  ophalen.
                </div>
                <div class="form-group">
                  <label><b>Voorkeur ophaaldatum</b></label>
                  <small style="padding-bottom: 10px; color:#dc3545 !important;" class="form-text text-muted">Deze
                    datum is een voorkeur. Na het plannen communiceren wij de
                    exacte ophaaldatum en tijd.<br></small>
                    <div style="padding-left: 0px !important;" class="input-group col-md-4">
                      <select class="form-select" formControlName="pickupDate" aria-label="Voorkeur ophaaldatum"
                        [ngClass]="{ 'is-invalid': submitted && f.pickupDate.errors }">
                        <option value="" selected>Selecteer...</option>
                        @for (date of dateRange; track date) {
                          <option [value]="date.date">{{date.date | date:
                          'dd-MM-yyyy'}}</option>
                        }
                      </select>
                      @if (submitted && f.pickupDate.errors) {
                        <div class="invalid-feedback">
                          @if (f.pickupDate.errors.required) {
                            <div>Selecteer een ophaaldatum.
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <label for="exampleInputEmail1"><b>Adresgegevens</b></label>
                  <div class="row">
                    <div class="form-group col">
                      <input formControlName="invoiceStreet" type="text" class="form-control"
                        placeholder="Straatnaam"
                        [ngClass]="{ 'is-invalid': submitted && f.invoiceStreet.errors }">
                      @if (submitted && f.invoiceStreet.errors) {
                        <div class="invalid-feedback">
                          @if (f.invoiceStreet.errors.required) {
                            <div>Straat is een verplicht veld.</div>
                          }
                          @if (f.invoiceStreet.errors.minlength) {
                            <div>Geen geldige straatnaam</div>
                          }
                        </div>
                      }
                    </div>
                    <div class="form-group col-md-3">
                      <input formControlName="invoiceNumber" type="number" class="form-control"
                        placeholder="Huisnummer"
                        [ngClass]="{ 'is-invalid': submitted && f.invoiceNumber.errors }">
                      @if (submitted && f.invoiceNumber.errors) {
                        <div class="invalid-feedback">
                          @if (f.invoiceNumber.errors.required) {
                            <div>Huisnummer is een verplicht veld.</div>
                          }
                          @if (f.invoiceNumber.errors.pattern) {
                            <div>Geen geldig huisnummer</div>
                          }
                        </div>
                      }
                    </div>
                    <div class="form-group col-md-5">
                      <input formControlName="invoiceNumberSuffix" type="text" class="form-control"
                        placeholder="Toevoeging huisnummer"
                        [ngClass]="{ 'is-invalid': submitted && f.invoiceNumberSuffix.errors }">
                      @if (submitted && f.invoiceNumberSuffix.errors) {
                        <div class="invalid-feedback">
                          @if (f.invoiceNumberSuffix.errors.required) {
                            <div>Toevoeging is een verplicht veld.
                            </div>
                          }
                          @if (f.invoiceNumberSuffix.errors.pattern) {
                            <div>Geen geldige toevoeging</div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="row">
                      <div class="form-group col-md-4">
                        <input formControlName="invoicePostalCode" type="text" class="form-control"
                          placeholder="Postcode"
                          [ngClass]="{ 'is-invalid': submitted && f.invoicePostalCode.errors }">
                        @if (submitted && f.invoicePostalCode.errors) {
                          <div class="invalid-feedback">
                            @if (f.invoicePostalCode.errors.required) {
                              <div>Postcode is een verplicht veld.
                              </div>
                            }
                            @if (f.invoicePostalCode.errors.pattern) {
                              <div>Geen geldige postcode (1234AB)</div>
                            }
                          </div>
                        }
                      </div>
                      <div class="form-group col">
                        <input formControlName="invoiceCity" type="text" class="form-control"
                          placeholder="Plaats"
                          [ngClass]="{ 'is-invalid': submitted && f.invoiceCity.errors }">
                        @if (submitted && f.invoicePostalCode.errors) {
                          <div class="invalid-feedback">
                            @if (f.invoiceCity.errors.required) {
                              <div>Plaats is een verplicht veld.</div>
                            }
                            @if (f.invoiceCity.errors.minlength) {
                              <div>Geen geldige plaats</div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <small class="form-text text-muted">Wij hebben je adres nodig zodat we de auto kunnen komen
                    ophalen.</small>
                  </div>
                  <div class="form-group">
                    <label><b>Is het ophaal adres anders?</b></label>
                    <div class="row">
                      <div class="form-group col">
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" (change)="handleInvoiceAddressChange(true)"
                            class="custom-control-input" id="invoiceAddressSameRadioTrue"
                            name="invoiceAddressSameRadio" value="true">
                          <label class="custom-control-label" for="invoiceAddressSameRadioTrue">Ja</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input type="radio" (change)="handleInvoiceAddressChange(false)"
                            class="custom-control-input" id="invoiceAddressSameRadioFalse"
                            name="invoiceAddressSameRadio" value="false">
                          <label class="custom-control-label" for="invoiceAddressSameRadioFalse">Nee</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (customPickupAddress ==  true) {
                    <div class="form-group">
                      <label for="exampleInputEmail1"><b>Ophaal adres</b></label>
                      <div class="row">
                        <div class="form-group col">
                          <input formControlName="pickupStreet" type="text" class="form-control"
                            placeholder="Straatnaam">
                        </div>
                        <div class="form-group col-md-3">
                          <input formControlName="pickupNumber" type="number" class="form-control"
                            placeholder="Huisnummer">
                        </div>
                        <div class="form-group col-md-5">
                          <input formControlName="pickupNumberSuffix" type="text" class="form-control"
                            placeholder="Toevoeging huisnummer">
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="row">
                          <div class="form-group col-md-4">
                            <input formControlName="pickupPostalcode" type="text" class="form-control"
                              placeholder="Postcode">
                          </div>
                          <div class="form-group col">
                            <input formControlName="pickupCity" type="text" class="form-control"
                              placeholder="Plaats">
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (customPickupAddress ==  true || customPickupAddress ==  false) {
                    <div>
                      <label for="exampleInputEmail1"><b>Betaalinformatie</b></label>
                      <div class="row">
                        <div class="form-group col-md-4">
                          <input formControlName="iban" type="text" class="form-control" placeholder="IBAN"
                            [ngClass]="{ 'is-invalid': submitted && f.iban.errors }"
                            [value]="f.iban.value | ibanFormatter">
                          @if (submitted && f.iban.errors) {
                            <div class="invalid-feedback">
                              @if (f.iban.errors.required) {
                                <div>IBAN is een verplicht veld.</div>
                              }
                            </div>
                          }
                          @if (submitted && f.iban.invalid) {
                            <div class="invalid-feedback">
                              @if (f.iban.errors.required) {
                                <div>Dit is geen geldige IBAN.</div>
                              }
                            </div>
                          }
                          @if (f.iban.invalid && (f.iban.dirty || f.iban.touched)) {
                            <div
                              class="invalid-feedback-text">
                              @if (f.iban.errors.iban) {
                                <div>
                                  Dit is geen geldige IBAN.
                                </div>
                              }
                            </div>
                          }
                          @if (f.iban.valid && (f.iban.dirty || f.iban.touched)) {
                            <div
                              class="valid-feedback-text">
                              ✅ IBAN is geldig.
                            </div>
                          }
                        </div>
                        <div class="form-group col-md-4">
                          <input formControlName="bankAccountName" type="text" class="form-control"
                            placeholder="Ter name van"
                            [ngClass]="{ 'is-invalid': submitted && f.bankAccountName.errors }">
                          @if (submitted && f.bankAccountName.errors) {
                            <div class="invalid-feedback">
                              @if (f.bankAccountName.errors.required) {
                                <div>Ter name van is een verplicht veld.
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      @if (showFrontUpload  == true || showBackUpload == true) {
                        <div class="form-group">
                          <label><b>Kopie RDW kentekencard</b></label>
                          <div ngbAccordion>
                            <div ngbAccordionItem [collapsed]="true">
                              <h2 ngbAccordionHeader>
                                <button class="btn btn-primary" ngbAccordionButton>Voorbeeld...</button>
                              </h2>
                              <div ngbAccordionCollapse>
                                <div ngbAccordionBody>
                                  <ng-template>
                                    <p>Deze gegevens hebben wij nodig om je voertuig te kunnen verwerken.
                                      Zorg
                                    ervoor dat de foto's duidelijk leesbaar zijn.</p>
                                    <img src="../../assets/images/kentekencard-voorkant.jpg"
                                      class="card-image img-fluid" alt="Kentekencard voorkant">
                                    <img src="../../assets/images/kentekencard-achterkant.jpg"
                                      class="card-image img-fluid" alt="Kentekencard achterkant">
                                  </ng-template>
                                </div>
                              </div>
                            </div>
                          </div>
                          @if (uploadDocumentError != '') {
                            <div class="alert alert-danger" role="alert">
                              {{uploadDocumentError | json}}
                            </div>
                          }
                          <div class="row">
                            <div class="form-group col-md-8">
                              @if (documentUploading) {
                                <div class="progress">
                                  <div class="progress-bar progress-bar-striped progress-bar-animated"
                                    style="width: 100%">
                                  Bezig met uploaden...</div>
                                </div>
                              }
                            </div>
                          </div>
                          <div class="row">
                            @if (showFrontUpload == true) {
                              <div class="form-group col-md-4">
                                <div class="custom-file">
                                  <input
                                    (change)="uploadValuationDocument('registrationcard_front', $event.target.files)"
                                    formControlName="licenseCardFront" type="file" class="custom-file-input"
                                    id="customFile" accept="image/*, .heic"
                                    [ngClass]="{ 'is-invalid': submitted && f.licenseCardFront.errors }">
                                  <label class="custom-file-label" for="customFile">Voorkant kentekencard</label>
                                  @if (submitted && f.licenseCardFront.errors) {
                                    <div class="invalid-feedback">
                                      @if (f.licenseCardFront.errors.required) {
                                        <div> Upload een bestand
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                                @if (frontUploadOk) {
                                  <div style="margin-top: 10px;" class="alert alert-success"
                                    role="alert">
                                    Bestand is opgeslagen
                                  </div>
                                }
                              </div>
                            }
                            @if (showBackUpload == true) {
                              <div class="form-group col-md-4">
                                <div class="custom-file">
                                  <input
                                    (change)="uploadValuationDocument('registrationcard_back', $event.target.files)"
                                    formControlName="licenseCardBack" type="file" class="custom-file-input"
                                    id="customFile" accept="image/*, .heic"
                                    [ngClass]="{ 'is-invalid': submitted && f.licenseCardBack.errors }">
                                  <label class="custom-file-label" for="customFile">Achterkant
                                  kentekencard</label>
                                  @if (submitted && f.licenseCardBack.errors) {
                                    <div class="invalid-feedback">
                                      @if (f.licenseCardBack.errors.required) {
                                        <div> Upload een bestand
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                                @if (backUploadOk) {
                                  <div style="margin-top: 10px;" class="alert alert-success"
                                    role="alert">
                                    Bestand is opgeslagen
                                  </div>
                                }
                              </div>
                            }
                          </div>
                          <small class="form-text text-muted">Zorg ervoor dat de foto's duidelijk leesbaar
                          zijn.</small>
                        </div>
                      }
                      <div class="form-group">
                        <div class="form-check">
                          <input formControlName="agreement" type="checkbox" class="form-check-input"
                            id="exampleCheck1" [ngClass]="{ 'is-invalid': submitted && f.agreement.errors }">
                          <label class="form-check-label" for="exampleCheck1">Bovenstaande gegevens heb ik correct
                            ingevoerd en ik ga akkoord met de <a target="_blank"
                          href="https://autoverkooppartner.nl/wp-content/uploads/2021/03/Algemene-Voorwaarden-AVP-1.0.pdf">voorwaarden</a>.</label>
                          @if (submitted && f.agreement.errors) {
                            <div class="invalid-feedback">
                              @if (f.agreement.errors.required) {
                                <div>Je bent niet akkoord gegaan met de
                                  voorwaarden.
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-md-4">
                          <button class="btn btn-primary" (click)="onSubmit()">Versturen</button>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </form>
          </div>
        </div>
      </div>